// @ts-nocheck
goog.module('yext.ui.components.i18n');

goog.require('goog.i18n.DateTimeSymbols');
const {setDateIntervalSymbols} = goog.require('goog.i18n.dateIntervalSymbols');

if (window.DateTimeSymbols) {
  goog.i18n.DateTimeSymbols = window.DateTimeSymbols;
}

if (window.DateIntervalSymbols) {
  setDateIntervalSymbols(window.DateIntervalSymbols);
}
